import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
import { DamzState, MessageAttachment, UnfurlLogEntry } from '../../types';
import { PapiUser } from '@wix/da-papi-types';

export const setDraftMessage = createAction(
  `${reduxKey}.DAMZ_DRAFT_SET_MSG`,
  (text: string, room_id: string, editMessageId: string | undefined) => ({
    text,
    room_id,
    editMessageId,
  })
);

export const clearDraft = createAction(
  `${reduxKey}.DAMZ_DRAFT_CLEAR`,
  room_id => ({ room_id })
);

export const clearDrafts = createAction(
  `${reduxKey}.DAMZ_DRAFT_CLEAR_ALL`,
  () => ({})
);

export const setDraftParticipants = createAction(
  `${reduxKey}.DAMZ_DRAFT_SET_PARTICIPANTS`,
  (participants: PapiUser[]) => ({ participants })
);

export const addDraftAttachment = createAction(
  `${reduxKey}.DAMZ_DRAFT_ATTACH`,
  (attachment: MessageAttachment, room_id: string) => ({ attachment, room_id })
);

export const removeDraftAttachment = createAction(
  `${reduxKey}.DAMZ_DRAFT_ATTACH_REMOVE`,
  (room_id: string, index) => ({
    room_id,
    index,
  })
);

export const maybeUnfurlLinks = createAction(
  `${reduxKey}.DAMZ_DRAFT_UNFURL`,
  (room_id, links) => ({ room_id, links })
);

export const logUnfurlLink = createAction(
  `${reduxKey}.DAMZ_DRAFT_UNFURL_LOG`,
  (room_id: string, links: UnfurlLogEntry[]) => ({ room_id, links })
);

export const replaceUnfurlLog = createAction(
  `${reduxKey}.DAMZ_DRAFT_UNFURL_SET`,
  (room_id: string, links: UnfurlLogEntry[]) => ({ room_id, links })
);

export const markUnfurlResolving = createAction(
  `${reduxKey}.DAMZ_DRAFT_UNFURL_RESOLVE`,
  () => ({})
);

export const markUnfurlFinished = createAction(
  `${reduxKey}.DAMZ_DRAFT_UNFURL_FIN`,
  () => ({})
);

export const addDraftUser = createAction(
  `${reduxKey}.DAMZ_DRAFT_USER_ADD`,
  (user: PapiUser, room_id: string) => ({ user, room_id })
);

export const removeDraftUser = createAction(
  `${reduxKey}.DAMZ_DRAFT_USER_REMOVE`,
  (user: PapiUser, room_id: string) => ({ user, room_id })
);

export const removeDraftUserAll = createAction(
  `${reduxKey}.DAMZ_DRAFT_USER_REMOVE_ALL`,
  (room_id: string) => ({ room_id })
);

export const hydrateDraft = createAction(
  `${reduxKey}.DAMZ_DRAFT_HYDRATE`,
  (data: DamzState['drafts']) => ({ data })
);

export const disallowDraftMessage = createAction(
  `${reduxKey}.DAMZ_DRAFT_DISALLOW_MESSAGE`,
  (room_id: string) => ({ room_id })
);

export const allowDraftMessage = createAction(
  `${reduxKey}.DAMZ_DRAFT_ALLOW_MESSAGE`,
  (room_id: string) => ({ room_id })
);

export const startImageUpload = createAction(
  `${reduxKey}.DAMZ_DRAFT_START_IMAGE_UPLOAD`,
  (roomId: string, file: File, fileId: string) => ({
    roomId,
    file,
    fileId,
  })
);

export const startMultipleImageUpload = createAction(
  `${reduxKey}.DAMZ_DRAFT_START_MULTIPLE_IMAGE_UPLOAD`,
  (roomId: string, files: File[]) => ({ roomId, files })
);

export const addUploadProgressAttachment = createAction(
  `${reduxKey}.DAMZ_DRAFT_ADD_UPLOAD_PROGRESS`,
  (roomId: string, fileId: string, file: File) => ({ roomId, fileId, file })
);

export const updateUploadProgress = createAction(
  `${reduxKey}.DAMZ_DRAFT_UPDATE_UPLOAD_PROGRESS`,
  (roomId: string, fileId: string, progress: number) => ({
    roomId,
    fileId,
    progress,
  })
);

export const completeImageUpload = createAction(
  `${reduxKey}.DAMZ_DRAFT_COMPLETE_IMAGE_UPLOAD`,
  (roomId: string, fileId: string, stashItem: any) => ({
    roomId,
    fileId,
    stashItem,
  })
);

export const failImageUpload = createAction(
  `${reduxKey}.DAMZ_DRAFT_FAIL_IMAGE_UPLOAD`,
  (roomId: string, fileId: string, error: string) => ({ roomId, fileId, error })
);

export const cancelImageUpload = createAction(
  `${reduxKey}.DAMZ_DRAFT_CANCEL_IMAGE_UPLOAD`,
  (roomId: string, fileId: string) => ({ roomId, fileId })
);
